import { Box, Modal,} from '@material-ui/core'
import React, { useEffect, useState } from 'react'


const AdvertisingModal = () => {
    const [isOpenModal, setIsOpenModal] = useState(false)
    useEffect(()=>{
        const isModalAdvertisingActive = localStorage.getItem("modal_advertisment_payment")
        if(isModalAdvertisingActive !== "inactive") setIsOpenModal(true)
    },[])

    const handleClickButton = ()=>{
        setIsOpenModal(false)
        localStorage.setItem("modal_advertisment_payment", "inactive")
    }

    if(!isOpenModal) return null
    return (

    <Modal open ={isOpenModal} >
       <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          overflowY: "auto",   
          overflowX: "hidden", 
          borderRadius: 2,
          p: 4,
          width: "80vw",      
          maxHeight:"500px",
          maxWidth: "650px", 
          border:"none",
          outline: "none",
        }}
      >      
        <div className="d-flex align-items-center justify-content-evenly">
            <h4>Aviso importante</h4>
            <div className='vr'></div>
               <img src="/images/logo.jpg" alt="logo" className="w-50" />
              </div>
              <div className='d-flex flex-column justify-content-center mt-2'>

                    <p>Estimado cliente: </p>
                    <p>Derivado de una actualización reciente en nuestro portal, ahora se visualiza el ícono de BBVA  </p>

                    <div className="mx-auto ">
                        <div className='d-flex align-items-center mb-2'>

                                 <input   type="radio" id="bbva" value="bbva" name="banco" disabled={true}/>
                                  <label style={{"margin-left":"0.5rem", "margin-bottom":"0.5rem"}} className="" htmlFor="bancomer">
                                    <img className="logo-banco ml-5" src="/logos/boton-bancomer.svg" alt="BBVA" />
                                  </label>
                        </div>
                    </div>
                    <p>durante el proceso de pago.
                        Para continuar con su pago, seleccione dicho ícono, ya que este forma parte del mismo proceso normal de pago que se ha utilizado previamente.
                        Esta actualización no modifica el flujo ni las condiciones de su pago, únicamente corresponde a una mejora visual y operativa del portal.
                        Agradecemos su comprensión.</p>
                    <div className="mx-auto">
                       <button  className="custom-btn pt-2 pb-2 ps-3 pe-3"  onClick={handleClickButton}>Aceptar</button>
                    </div>
             </div>
          </Box>
      
    </Modal>
  )
}

export default AdvertisingModal
